// extracted by mini-css-extract-plugin
export default {"container":"LpToast_container__5L-Hd","toastText":"LpToast_toastText__m6DLZ","closeIcon":"LpToast_closeIcon__Cf1Vy"};